import classNames from 'classnames';
import { clamp } from 'lodash-es';
import React, { useCallback, useState } from 'react';
import type { GanttProjectRow } from '../gantt-types';
import styles from './LeftHeader.module.scss';

interface Props {
  row: GanttProjectRow;
  isLastRow: boolean;
  style: React.CSSProperties;
  rowHeight: number;
  scrollTop: number;
  overflowToNext: boolean;
  displayClient?: boolean;
}

const VERTICAL_PADDING = 8;
const LeftClientCell: React.FC<Props> = ({
  row,
  style,
  rowHeight,
  scrollTop,
  overflowToNext,
}: Props) => {
  // Make Client sticky during scroll
  const [cellHeight, setCellHeight] = useState<number>(0);
  const cellRowRef = useCallback((element: HTMLDivElement | null) => {
    setCellHeight(element?.offsetHeight ?? 0);
  }, []);
  const top = clamp(
    // Adjust top position based on scroll position
    scrollTop - Number(style.top!),
    0,
    overflowToNext
      ? // When the scroll is at the bottom of the row, the client name should overflow to the next row
        rowHeight
      : // When the scroll reached the last row of the client, the client name should not overflow to the next row
        rowHeight - cellHeight - VERTICAL_PADDING * 2
  );

  return (
    <div className={styles.leftHeaderCell}>
      <div className={styles.client} ref={cellRowRef} style={{ top }}>
        <div className={classNames(styles.name, 'fs-mask')}>{row.clientName}</div>
      </div>
    </div>
  );
};
export default LeftClientCell;
